import { IAttachment } from "../../caseLawDocuments/model/Attachment";
import Model from "../../core/model/Model";
import ValidatableObject from "../../core/model/validation/ValidatableObject";

export interface TCaseDecision {
  id: string;
  name: string;
  status: string;
  courtCaseId: number;
  caseNumber: string;
  documentTypeId: number;
  departmentId: number;
  organisationId: number;
  attachmentId: number;
  category: string;
  valid: boolean;
  attachment?: IAttachment;
  decisionDate: Date;
  decisionTypeId: number;
  extId: string;
  invalidatedBy: number;
}

export interface ICaseDecision extends TCaseDecision {}

const CaseDecision = Model((model: TCaseDecision): ICaseDecision => {
  const _value: TCaseDecision = Object.assign({}, model);

  let _model = {
    get id() {
      return _value.id;
    },
    set id(value) {
      _value.id = value;
    },
    get name() {
      return _value.name;
    },
    set name(value) {
      _value.name = value;
    },
    get status() {
      return _value.status;
    },
    set status(value) {
      _value.status = value;
    },
    get valid() {
      return _value.valid;
    },
    set valid(value) {
      _value.valid = value;
    },
    get courtCaseId() {
      return _value.courtCaseId;
    },
    set courtCaseId(value) {
      _value.courtCaseId = value;
    },
    get caseNumber() {
      return _value.caseNumber;
    },
    set caseNumber(value) {
      _value.caseNumber = value;
    },
    get documentTypeId() {
      return _value.documentTypeId;
    },
    set documentTypeId(value) {
      _value.documentTypeId = value;
    },
    get organisationId() {
      return _value.organisationId;
    },
    set organisationId(value) {
      _value.organisationId = value;
    },
    get departmentId() {
      return _value.departmentId;
    },
    set departmentId(value) {
      _value.departmentId = value;
    },
    get attachmentId() {
      return _value.attachmentId;
    },
    set attachmentId(value) {
      _value.attachmentId = value;
    },
    get attachment() {
      return _value.attachment;
    },
    set attachment(value) {
      _value.attachment = value;
    },
    get decisionDate() {
      return _value.decisionDate;
    },
    set decisionDate(value) {
      _value.decisionDate = value;
    },
    get category() {
      return _value.category;
    },
    set category(value) {
      _value.category = value;
    },
    get decisionTypeId() {
      return _value.decisionTypeId;
    },
    set decisionTypeId(value) {
      _value.decisionTypeId = value;
    },
    get extId() {
      return _value.extId;
    },
    set extId(value) {
      _value.extId = value;
    },
    get invalidatedBy() {
      return _value.invalidatedBy;
    },
    set invalidatedBy(value) {
      _value.invalidatedBy = value;
    }
  };

  return ValidatableObject<ICaseDecision>(_model);
});

export default CaseDecision;
